import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuItems = [
    { label: 'Home', href: '#home' },
    { label: 'Sobre', href: '#sobre' },
    { label: 'Serviços', href: '#servicos' },
    { label: 'Antes-Depois', href: '#resultados' },
    { label: 'Contato', href: '#contato' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 bg-[#f7f7f7] shadow-md z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-28">
          {/* Logo */}
          <div className="flex-shrink-0 pl-4">
            <a 
              href="/" 
              className="flex items-center focus:outline-none focus:ring-2 focus:ring-[#6B2432] focus:ring-offset-2 rounded-md"
            >
              <img
                src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/a81843f30b0191be37d7aae889c01ec9.png"
                alt="Logo Dr. Luiz Renato Kreb"
                className="h-auto w-[80px] min-w-[70px] max-w-[90px] sm:w-[90px] sm:max-w-[100px] xl:w-[100px] xl:max-w-[110px] object-contain"
              />
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              {menuItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="text-[#5A5A5A] hover:text-[#6B2432] px-3 py-2 text-base font-medium transition-colors duration-300 relative group"
                >
                  {item.label}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#6B2432] transition-all duration-300 group-hover:w-full"></span>
                </a>
              ))}
            </div>
          </div>

          {/* CTA Button - Desktop */}
          <div className="hidden md:block">
            <Button 
              href="https://wa.me/5544999297166"
              icon={<i className="ri-whatsapp-line"></i>}
            >
              WhatsApp (44) 99929-7166
            </Button>
          </div>

          {/* Mobile WhatsApp Button and Menu Button */}
          <div className="md:hidden flex items-center space-x-3">
            {/* Mobile WhatsApp Button */}
            <a
              href="https://wa.me/5544999297166"
              className="md:hidden bg-[#6B2432] text-white px-3 py-2 rounded-full hover:opacity-90 transition-all duration-300 flex items-center gap-2 text-sm font-medium whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              <span>Entre em Contato</span>
            </a>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-[#5A5A5A] hover:text-[#6B2432] focus:outline-none focus:text-[#6B2432] transition-colors duration-300"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-[#f7f7f7] border-t">
              {menuItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="text-[#5A5A5A] hover:text-[#6B2432] block px-3 py-2 text-base font-medium transition-colors duration-300"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <div className="pt-4">
                <Button 
                  href="https://wa.me/5544999297166"
                  icon={<i className="ri-whatsapp-line"></i>}
                  className="mobile-button w-full"
                >
                  WhatsApp (44) 99929-7166
                </Button>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
